<div class="flex justify-center">
    <h2 class="font-light leading-relaxed text-3xl py-8 text-gray-800 cursor-default"
        style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">{{city}} FUSILLI Impacts</h2>
</div>
<div class="w-2/3 px-8 py-4 mx-auto">
    <div class="shadow">
        <div class="border-b">
            <div class="border-l-2 border-transparent">
                <ng-container *ngFor="let impact of data; let i = index">
                    <div class="grid grid-cols-1 p-1 text-justify">
                        <div (click)="onClick(i)"
                            class="flex justify-center gap-2 text-xl p-2 font-light bg-headerto hover:bg-headerfr text-yellow-200 rounded-md cursor-pointer">
                            {{ impact.impact }}
                            <div class="rounded-full border border-grey w-7 h-7 flex items-center justify-center pointer-events-none"
                                *ngIf="!impact.expanded">
                                <svg aria-hidden="true" data-reactid="266" fill="none" height="24" stroke="#FFF59D"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24"
                                    width="24" xmlns="http://www.w3.org/2000/svg">
                                    <polyline points="6 9 12 15 18 9">
                                    </polyline>
                                </svg>
                            </div>
                            <div class="rounded-full border border-grey w-7 h-7 flex items-center justify-center pointer-events-none"
                                *ngIf="impact.expanded">
                                <svg aria-hidden="true" data-reactid="266" fill="none" height="24" stroke="#FFF59D"
                                    stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24"
                                    width="24" xmlns="http://www.w3.org/2000/svg">
                                    <polyline points="18 15 12 9 6 15">
                                    </polyline>
                                </svg>
                            </div>
                        </div>
                        <div *ngIf="impact.expanded">
                            <div class="shadow">
                                <div class="border-b">
                                    <div class="border-l-2 border-transparent">
                                        <div id="info" matTooltip="{{ impact.definition }}" matTooltipClass="text-md"
                                            matTooltipPosition="right"
                                            class="float-right font-light rounded h-3/4 px-4 py-2 bg-headerto hover:bg-headerfr text-yellow-200 hover:bg-buttonhover hover:text-colortext flex items-center mb-8 mr-1 cursor-pointer">
                                            <i class="fas fa-info text-3xl"></i>
                                        </div>
                                        <div class="my-8">
                                            <img src="../../../../../../assets/img/{{impact.level}}.png">
                                        </div>
                                        <div class="p-1 text-lg font-thin">
                                            {{ impact.info }}
                                        </div>
                                        <h4 class="mt-8 font-light leading-relaxed text-xl py-2 text-gray-800 cursor-default"
                                            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Results of KPIs related
                                        </h4>
                                        <div class="p-1 text-lg font-thin">
                                            <ul>
                                                <li *ngFor="let kpi of data[i].kpis" class="my-4">
                                                    <div class="p-1 text-lg font-thin rounded">
                                                        {{kpi.Kpi}}
                                                    </div>
                                                    <div class="text-sm font-thin text-gray-700">
                                                        {{kpi.Message}}
                                                    </div>
                                                    <div class="bg-evaluationto text-gray-100 rounded-full px-2 py-1 font-bold float-right">
                                                        {{kpi.Score}}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <h4 class="mt-8 font-light leading-relaxed text-xl py-2 text-gray-800 cursor-default"
                                            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Alignment with FOOD2030
                                            Priorities</h4>
                                        <div class="relative">
                                            <div class="flex justify-center items-center my-8">
                                                <img alt="..." src="../../../../../../assets/img/food2030.png"
                                                    class="w-64 relative object-scale-down">
                                                <button
                                                    class="absolute top-1/2 left-1/2 transform -translate-x-24 -translate-y-24 opacity-0"
                                                    (mouseenter)="buttonMouseover(1)"
                                                    (mouseleave)="buttonLeave()">NUTRITION</button>
                                                <button
                                                    class="absolute top-1/2 right-1/2 transform translate-x-24 -translate-y-24 opacity-0"
                                                    (mouseenter)="buttonMouseover(2)"
                                                    (mouseleave)="buttonLeave()">CLIMATE</button>
                                                <button
                                                    class="absolute bottom-1/2 left-1/2 transform -translate-x-24 translate-y-16 opacity-0"
                                                    (mouseenter)="buttonMouseover(3)"
                                                    (mouseleave)="buttonLeave()">INNOVATION</button>
                                                <button
                                                    class="absolute bottom-1/2 right-1/2 transform translate-x-24 translate-y-16 opacity-0"
                                                    (mouseenter)="buttonMouseover(4)"
                                                    (mouseleave)="buttonLeave()">CIRCULARITY</button>
                                                <div *ngIf="currentMouseover === 1"
                                                    class="absolute top-0 left-0 w-1/3 p-1 text-gray-100 rounded"
                                                    style="background-color: #39a935;">{{impact.nutrition_al}}</div>
                                                <div *ngIf="currentMouseover === 2"
                                                    class="absolute top-0 right-0 w-1/3 p-1 text-gray-100 rounded"
                                                    style="background-color: #5bc4f1;">{{impact.climate_al}}</div>
                                                <div *ngIf="currentMouseover === 3"
                                                    class="absolute bottom-0 left-0 w-1/3 p-1 text-gray-100 rounded"
                                                    style="background-color: #93c01f;">{{impact.innovation_al}}</div>
                                                <div *ngIf="currentMouseover === 4"
                                                    class="absolute bottom-0 right-0 w-1/3 p-1 text-gray-100 rounded"
                                                    style="background-color: #1d70b7;">{{impact.circularity_al}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div class="flex flex-cols-3 justify-center items-center mt-8 ">
    <div class="text-md font-light text-gray-500 items-center mx-4">
        Note:
    </div>
    <div class="flex flex-col items-center justify-center mx-1">
        <img src="../../../../../../assets/img/Limited.png">
        <div class="font-light leading-relaxed justify-center items-center text-lg text-gray-800 cursor-default"style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
            Limited Impact
        </div>
    </div>
    <div class="flex flex-col items-center justify-center mx-1">
        <img src="../../../../../../assets/img/Moderate.png">
        <div class="font-light leading-relaxed justify-center items-center text-lg text-gray-800 cursor-default"style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
            Moderate Impact
        </div>
    </div>
    <div class="flex flex-col items-center justify-center mx-1">
        <img src="../../../../../../assets/img/Positive.png">
        <div class="font-light leading-relaxed justify-center items-center text-lg text-gray-800 cursor-default"style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
            Positive Impact
        </div>
    </div>
</div>